<template>
  <div>
    <div class="row d-flex justify-content-center">
      <div class="col-md-10">
        <simple-wizard>
          <template slot="header">
            <h3 class="card-title">Avant de commencer...</h3>
            <h3 class="description">
              Merci de prendre connaissance des informations suivantes et de compléter votre profil. 
            </h3>
          </template>

          <wizard-tab :before-change="() => validateStep('step1')">
            <template slot="label">
              <i class="tim-icons icon-single-02"></i>
              <p>Avertissement</p>
            </template>
            <warning-step
              ref="step1"
              @on-validated="onStepValidated"
            ></warning-step>
          </wizard-tab>

          <wizard-tab :before-change="() => validateStep('step2')">
            <template slot="label">
              <i class="tim-icons icon-settings-gear-63"></i>
              <p>Capital</p>
            </template>
            <capital-step
              ref="step2"
              @on-validated="onStepValidated"
            ></capital-step>
          </wizard-tab>

          <wizard-tab :before-change="() => validateStep('step3')">
            <template slot="label">
              <i class="tim-icons icon-delivery-fast"></i>
              <p>Expérience</p>
            </template>
            <experience-step 
                ref="step3"
                @on-validated="wizardComplete"
            ></experience-step>
          </wizard-tab>
        </simple-wizard>
      </div>
    </div>
  </div>
</template>
<script>
import WarningStep from './Onboarding/WarningStep.vue';
import CapitalStep from './Onboarding/CapitalStep.vue';
import ExperienceStep from './Onboarding/ExperienceStep.vue';
import swal from 'sweetalert2';
import { SimpleWizard, WizardTab } from 'src/components';

export default {
  data() {
    return {
      wizardModel: {}
    };
  },
  components: {
    WarningStep,
    CapitalStep,
    ExperienceStep,
    SimpleWizard,
    WizardTab
  },
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    wizardComplete(validated, model) {
        this.wizardModel = { 
          ...this.wizardModel, 
          ...model, 
          cash: parseFloat(this.wizardModel.initialCapital),
        };
        this.$store.dispatch('auth/createconf', this.wizardModel);
        swal('Bienvenue à bord !', 'Vous allez maintenant accéder à votre tableau de bord :)', 'success').then( () => {
            // Update userconf and redirect to dashboard
        });
    }
  },
  metaInfo() {
    return {
      title: "Onboarding Peamoni"
    };
  },
};
</script>
